import { combineReducers, type Reducer } from 'redux';
import auth from './auth/auth.reducer';
import survey from './survey/survey.reducer';
import SurveyUsersSlice from '../survey/slices/SurveyUsersSlice';
import common from './common';
import { ProjectReducer } from '../participant/actions/ProjectActions';
import { UserReducer } from '../actions/UserActions';
import { AuthReducer as Auth2Reducer } from '../auth/actions/AuthActions';
import { QuestionnaireReducer } from '../participant/actions/QuestionnaireActions';
import AdminUsersSlice from '../admin/slices/AdminUsersSlice';
import IAdminReducer from '../admin/types/IAdminReducer';
import AdminCustomerSlice from '../admin/slices/AdminCustomerSlice';
import AdminDashboardSlice from '../admin/slices/AdminDashboardSlice';
import ICommonReducer from '../common/types/ICommonReducer';
import ParticipantReducer from '../participant/types/ParticipantReducer';
import DashboardSlice from '../participant/slices/DashboardSlice';
import AdminProjectSlice from '../admin/slices/AdminProjectSlice';
import AdminParticipantSlice from '../admin/slices/AdminParticipantSlice';
import AdminInviteSlice from '../admin/slices/AdminInviteSlice';
import Admin360QuestionnaireSlice from '../admin/slices/Admin360QuestionnaireSlice';
import Admin360ScaleSlice from '../admin/slices/Admin360ScaleSlice';
import Admin360GroupSlice from '../admin/slices/Admin360GroupSlice';
import Admin360ParticipantSlice from '../admin/slices/Admin360ParticipantSlice';
import AdminSortingCriteriaSlice from '../admin/slices/AdminSortingCriteriaSlice';
import AdminReportsSlice from '../admin/slices/AdminReportsSlice';
import AdminProjectAdminsSlice from '../admin/slices/AdminProjectAdminsSlice';
import AdminJobMatchSlice from '../admin/slices/AdminJobMatchSlice';
import AdminTeamSlice from '../admin/slices/AdminTeamSlice';
import AdminProjectStatisticsSlice from '../admin/slices/AdminProjectStatisticsSlice';

const mergedAuth = (
    state: Record<string, unknown> | undefined,
    action: { type: string },
) => {
    const { password, ...legacyAuthState } = (state ?? {}) as {
        password?: unknown;
        [key: string]: unknown;
    };

    const authState = auth(legacyAuthState as any, action);
    const auth2State = Auth2Reducer(
        state ? ({ password } as any) : undefined,
        action,
    );
    return {
        ...authState,
        password: auth2State.password,
    };
};

export const rootReducer = combineReducers({
    auth: mergedAuth,
    survey,
    users: SurveyUsersSlice.reducer,
    common,
    participant: combineReducers({
        project: ProjectReducer,
        dashboard: DashboardSlice.reducer,
    }),
    user: UserReducer,
    questionnaire: QuestionnaireReducer,
    admin: combineReducers({
        users: AdminUsersSlice.reducer,
        customer: AdminCustomerSlice.reducer,
        dashboard: AdminDashboardSlice.reducer,
        project: AdminProjectSlice.reducer,
        participants: AdminParticipantSlice.reducer,
        invite: AdminInviteSlice.reducer,
        360: combineReducers({
            scales: Admin360ScaleSlice.reducer,
            questionnaire: Admin360QuestionnaireSlice.reducer,
            groups: Admin360GroupSlice.reducer,
            participant: Admin360ParticipantSlice.reducer,
        }),
        criteria: AdminSortingCriteriaSlice.reducer,
        reports: AdminReportsSlice.reducer,
        admins: AdminProjectAdminsSlice.reducer,
        jobMatch: AdminJobMatchSlice.reducer,
        teams: AdminTeamSlice.reducer,
        projectStatistics: AdminProjectStatisticsSlice.reducer,
    }),
}) as Reducer<AppState>;

export type AppState = any & {
    admin: IAdminReducer;
    common: ICommonReducer;
    participant: ParticipantReducer;
};
